import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcessVblExportParamStatus: 'idle',
    startProcessVblExportParamError: undefined as any,
    loadUserParamsProcessVblExportParamStatus: 'idle',
    loadUserParamsProcessVblExportParamError: undefined as any,

    processVblExportParamList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcessVblExportParam = createAsyncThunk('processVblExportParamSlice/startProcessVblExportParam', async ({ processVblExportParam }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcessVblExportParam/`,
        prepareData(processVblExportParam),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcessVblExportParamStatus } = getState().processVblExportParamSlice
        return startProcessVblExportParamStatus !== 'pending'
    }
})

export const loadUserParamsProcessVblExportParam = createAsyncThunk('processVblExportParamSlice/loadUserParamsProcessVblExportParam', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcessVblExportParam/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcessVblExportParamStatus } = getState().processVblExportParamSlice
        return loadUserParamsProcessVblExportParamStatus !== 'pending'
    }
})

const ProcessVblExportParamSlice = createSlice({
    name: 'processVblExportParamSlice',
    initialState,
    reducers: {
        resetstartProcessVblExportParam: (state) => {
            state.job = undefined
            state.startProcessVblExportParamError = undefined
        },
        resetstartProcessVblExportParamError: (state) => {
            state.startProcessVblExportParamError = undefined
        },
        resetloadUserParamsProcessVblExportParam: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcessVblExportParamError = undefined
        },
        resetloadUserParamsProcessVblExportParamError: (state) => {
            state.loadUserParamsProcessVblExportParamError = undefined
        },
        removeFromProcessVblExportParamListById: (state, action) => {
            state.processVblExportParamList = state.processVblExportParamList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcessVblExportParamListByIds: (state, action) => {
            state.processVblExportParamList = state.processVblExportParamList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.processVblExportParamList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcessVblExportParamStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.processVblExportParamList = []
            state.startProcessVblExportParamStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcessVblExportParam.pending, (state) => {
            state.startProcessVblExportParamStatus = 'pending'
            state.startProcessVblExportParamError = undefined
        })
        builder.addCase(startProcessVblExportParam.fulfilled, (state, action) => {
            state.startProcessVblExportParamStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcessVblExportParam.rejected, (state, action) => {
            state.startProcessVblExportParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcessVblExportParamError = action.error.message
            } else {
                state.startProcessVblExportParamError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcessVblExportParam.pending, (state) => {
            state.loadUserParamsProcessVblExportParamStatus = 'pending'
            state.loadUserParamsProcessVblExportParamError = undefined
        })
        builder.addCase(loadUserParamsProcessVblExportParam.fulfilled, (state, action) => {
            state.loadUserParamsProcessVblExportParamStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcessVblExportParam.rejected, (state, action) => {
            state.loadUserParamsProcessVblExportParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcessVblExportParamError = action.error.message
            } else {
                state.loadUserParamsProcessVblExportParamError = action.payload
            }
        })

    }
})

export const {
    resetstartProcessVblExportParam,
    resetstartProcessVblExportParamError,
    resetloadUserParamsProcessVblExportParam,
    resetloadUserParamsProcessVblExportParamError,
    removeFromProcessVblExportParamListById,
    removeFromProcessVblExportParamListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = ProcessVblExportParamSlice.actions
export default ProcessVblExportParamSlice.reducer
